import React from "react";
import {
  CertificateIcon, Lightning, CurrencyDollarSimple, MapPin, MonitorPlay, Lock, Medal, ShieldCheck,
} from "@phosphor-icons/react";

const SafeCertificate = CertificateIcon || ShieldCheck;

const REASONS = [
  { icon: SafeCertificate, title: "Certified technicians", desc: "CompTIA A+ and Microsoft Certified — not your nephew with a YouTube tutorial." },
  { icon: Lightning, title: "Fast response times", desc: "Under 15-minute average response. Same-day on-site appointments across NC." },
  { icon: CurrencyDollarSimple, title: "Transparent pricing", desc: "Flat-rate jobs and per-user MSP plans. No surprise invoices, no nickel-and-diming." },
  { icon: MapPin, title: "Local NC company", desc: "Owned, operated, and answered in North Carolina — every call hits a local technician." },
  { icon: MonitorPlay, title: "Remote & on-site support", desc: "Most issues solved remotely in minutes. On-site visits when hands need to touch hardware." },
  { icon: Lock, title: "Secure business solutions", desc: "EDR, MFA, encrypted backups, and compliance-ready stacks for HIPAA / PCI / SOC2." },
  { icon: Medal, title: "Satisfaction guarantee", desc: "No-fix-no-fee on repairs · 7-day satisfaction window on tune-ups · SLA credits on MSP plans." },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-choose-section"
      className="bg-zinc-50 py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-sm font-semibold uppercase tracking-widest text-blue-600">
            The TechConnect difference
          </div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-zinc-900">
            Why businesses choose TechConnect LLC.
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                data-testid={`why-reason-${i}`}
                className="bg-white border border-zinc-200 rounded-2xl p-6 hover:border-blue-300 hover:shadow-lg transition-all"
              >
                <div className="h-11 w-11 rounded-xl bg-blue-600 text-white grid place-items-center">
                  <Icon size={20} weight="duotone" />
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-zinc-900">{r.title}</h3>
                <p className="mt-2 text-sm text-zinc-600 leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
